import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/sharp-solid-svg-icons';
import React, { useCallback, useState } from 'react';
import './index.css';

export const SecureButton: React.FC<{
  defaultSecure: boolean;
  onChange: (secure: boolean) => void;
}> = ({ defaultSecure, onChange }) => {
  const [secure, setSecure] = useState(defaultSecure);
  const handleShow = useCallback(() => {
    setSecure(false);
    onChange(false);
  }, []);
  const handleHide = useCallback(() => {
    setSecure(true);
    onChange(true);
  }, []);
  return (
    <button className="secure_button" type="button" onClick={!secure ? handleHide : handleShow}>
      {!secure ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
    </button>
  );
};
